<template>
          
    <header id="sign-header" class="sign-interface-header d-flex flex-column flex-xl-row flex-wrap justify-content-between align-items-xl-center py-4 mb-xl-4 px-3  px-xxl-5">
      <i class="material-symbols-rounded fsz-20 fw-Bold options d-block d-xl-none cursor-pointer"
      @click.prevent="$router.back()">
        west
      </i>
      <nuxt-link href="/" class="d-flex align-items-center ps-xl-2  mb-md-0 me-md-auto m-auto m-xl-0">
        <img class="d-none d-xl-block"  src="~/assets/images/logos/top-auto-logo.svg" alt="">
        
      </nuxt-link>
    </header>
    
      <div class="d-flex no-gutter ">
          <!-- The image half -->
          <div class=" d-none d-xl-flex login-side justify-content-center align-items-center bg-img " >
              <div>
                <h1 class="h2 text-white mb-3">
                  Accéder à toute l’expérience & vendez 
                votre voiture facilement
                </h1>
                <p class="mb-4">
                  Topauto est à la bonne adresse pour vendre ta voiture simplement et rapidement dans toute la Tunisie. Devenir membre enregistré de Topauto facilite la publication et la gestion de vos annonces.             
                </p>
                <ul class="details-list mt-3">
                  <li class="d-flex align-items-center">
                    <i class="material-symbols-rounded fsz-24">favorite</i>
  
  
                      <span>
                        Accéder à vos véhicules préférés sur tous vos appareils
                      </span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="material-symbols-rounded fsz-24">bookmarks</i>
  
  
                    <span>
                      Sauvegarder les recherches pour faire le suivi des véhicules ajoutés récemment
                    </span>
                </li>
                <li class="d-flex align-items-center">
                  <i class="material-symbols-rounded fsz-24">chat_bubble</i>
  
  
                  <span>
                    Envoyer et recevoir facilement vos messages
                  </span>
              </li>
              </ul>
              </div>
          </div>
          
    
        
          <div class="col bg-white">
            
              <div class="login d-flex flex-column flex-xl-row  justify-content-between  align-items-xl-center py-xl-32">
                
                  <div class="d-flex justify-content-center align-items-center pt-32">
                  </div>
               
                  <div class=" page-container p-md-0 sigin-container mx-auto">
                    <nuxt-link to="/" class="d-flex d-xl-none justify-content-center align-items-center pb-5">
                      <img class="pt-5" src="~/assets/images/logos/top-auto-logo-black.svg" alt="">
                    </nuxt-link>
                   
                          <div class="sigin-container mx-auto col-12 px-3 ">
                              <!-- signin section -->
    
                              <div class="col-12">
  
                               <slot></slot>
  
                                
                              </div>
    
                            </div>
    
                  </div>
                  <!-- End -->
                  <div class="auth-footer">
                    <div class=" d-flex  justify-content-between align-items-center">
                      <nuxt-link target="_blank" to="/">© 2025 topauto.tn</nuxt-link>
                      
                      <nuxt-link :to="'mailto:help@topauto.tn'">help@topauto.tn</nuxt-link>
                      
                    </div>
                  </div>
    
              </div>
    
          </div>
          <!-- End -->
    
      </div>
  </template>
  
  <script setup>
  
  </script>
  
  <style lang="scss" scoped>

  .bg-img{
    background-image: url(~/assets/images/backgrounds/Topauto_-_Créez_votre_compte_–_BG.svg);
  }
  </style>